import React, { useState, useEffect ,useRef} from "react";
import axios from "axios";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import '../styles/DdCollectionReport.css'

const DdCollectionReport = () => {
  const superAdminId = Number(localStorage.getItem("adminuserId")) || 0;

  const [records, setRecords] = useState([]);
  const [company, setCompany] = useState(null);
  const [loading, setLoading] = useState(true);

  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [selectedCustomer,setSelectedCustomer]=useState(null);
  const slipRef=useRef(null);


  // -----------------------------------
  // API ENDPOINT FOR PAID INSTALLMENTS
  // -----------------------------------
  const API_URL = `https://payyug.in/api/installments/paid?superAdminId=${superAdminId}`;

  // FETCH INSTALLMENTS
  useEffect(() => {
    const fetchRecords = async () => {
      setLoading(true);
      try {
        const res = await axios.get(API_URL);
        setRecords(res.data.data || []);
      } catch (err) {
        console.log(err);
      } finally {
        setLoading(false);
      }
    };
    fetchRecords();
  }, []);

  // FETCH COMPANY
  useEffect(() => {
    const fetchCompany = async () => {
      try {
        const res = await fetch(
          `https://payyug.in/api/get-company?superAdminId=${superAdminId}`
        );
        const data = await res.json();
        const info = data.data || data;

        if (info.logo)
          info.logoUrl = `https://payyug.in/${info.logo.replace(/^images\//, "")}`;

        setCompany(info);
      } catch (err) {
        console.log("Company fetch error", err);
      }
    };
    fetchCompany();
  }, []);

  // -----------------------------------
  // PAGINATION
  // -----------------------------------
  const totalPages = Math.ceil(records.length / rowsPerPage);
  const startIndex = (currentPage - 1) * rowsPerPage;
  const currentData = records.slice(startIndex, startIndex + rowsPerPage);

  const handlePrev = () => currentPage > 1 && setCurrentPage(currentPage - 1);
  const handleNext = () =>
    currentPage < totalPages && setCurrentPage(currentPage + 1);

  // -----------------------------------
  // TOTAL AMOUNT
  // -----------------------------------
  const totalAmount = currentData.reduce((acc, r) => acc + (r.amount || 0), 0);

  // -----------------------------------
  // EXPORT PDF
  // -----------------------------------
  // const downloadPDF = () => {
  //   const doc = new jsPDF("p", "mm", "a4");
  //   const pageWidth = doc.internal.pageSize.width;

  //   doc.setFont("helvetica", "bold");
  //   doc.setFontSize(15);
  //   doc.text("Deposit Collection Report", pageWidth / 2, 14, {
  //     align: "center",
  //   });

  //   autoTable(doc, {
  //     startY: 22,
  //     head: [
  //       [
  //         "Sr",
  //         "Customer",
  //         "Account No",
  //         "Installment",
  //         "Amount",
  //         "Due Date",
  //         "Paid Date",
  //         "Mode",
  //       ],
  //     ],
  //     body: currentData.map((r, i) => [
  //       startIndex + i + 1,
  //       r.account?.customerName,
  //       r.account?.accountNo,
  //       r.installmentNo,
  //       r.amount,
  //       new Date(r.dueDate).toLocaleDateString("en-IN"),
  //       r.collectionDate
  //         ? new Date(r.collectionDate).toLocaleDateString("en-IN")
  //         : "-",
  //       r.collectionType || "-",
  //     ]),
  //     theme: "grid",
  //   });

  //   doc.save("Deposit_Collection_Report.pdf");
  // };


  const downloadPDF = async () => {
    const doc = new jsPDF("p", "mm", "a4");
    const pageWidth = doc.internal.pageSize.width;
    const pageHeight = doc.internal.pageSize.height;
  
    // ================= LOGO =================
  // ================= LOGO WITH BORDER =================
  const logoX = 15;
  const logoY = 12;
  const logoSize = 25;
  const logoPadding = 2;
  
  // Border color & thickness
  doc.setDrawColor(0);
  doc.setLineWidth(0.2);
  
  // Calculate center of logo
  const centerX = logoX + logoSize / 2;
  const centerY = logoY + logoSize / 2;
  
  // Radius = half of logo + padding
  const radius = logoSize / 2 + logoPadding;
  
  // Draw circle
  doc.circle(centerX, centerY, radius);
  
  
  // Logo image
  if (company?.logoUrl) {
    try {
      const logoResp = await fetch(company.logoUrl);
      const logoBlob = await logoResp.blob();
      const reader = new FileReader();
      await new Promise((resolve) => {
        reader.onload = () => {
          doc.addImage(reader.result, "PNG", logoX, logoY, logoSize, logoSize);
          resolve();
        };
        reader.readAsDataURL(logoBlob);
      });
    } catch {
      // silent fail
    }
  }
  
  
    // ================= COMPANY NAME (AUTO WRAP) =================
    doc.setFont("helvetica", "bold");
    doc.setFontSize(14);
  
    const nameX = logoX + logoSize + 5;
    const nameY = 18;
    const nameMaxWidth = pageWidth - nameX - 15;
  
    const companyNameText = doc.splitTextToSize(
      (company?.name || "COMPANY NAME").toUpperCase(),
      nameMaxWidth
    );
  
    doc.text(companyNameText, nameX, nameY);
  
    // Calculate Y after company name
    let currentY = nameY + companyNameText.length * 6;
  
    // ================= COMPANY DETAILS =================
    doc.setFont("helvetica", "normal");
    doc.setFontSize(11);
  
    const detailX = nameX;
    const detailMaxWidth = nameMaxWidth;
  
    // Address
    const addressText = doc.splitTextToSize(
      company?.address || "Company Address",
      detailMaxWidth
    );
    doc.text(addressText, detailX, currentY);
    currentY += addressText.length * 5;
  
    // Email
    const emailText = doc.splitTextToSize(
      `Email: ${company?.email || "-"}`,
      detailMaxWidth
    );
    doc.text(emailText, detailX, currentY);
    currentY += emailText.length * 5;
  
    // Phone
    const phoneText = doc.splitTextToSize(
      `Phone: ${company?.contact || "-"}`,
      detailMaxWidth
    );
    doc.text(phoneText, detailX, currentY);
    currentY += phoneText.length * 5;
  
    // Divider
    doc.line(10, currentY + 4, pageWidth - 10, currentY + 4);
  
    // ================= REPORT TITLE =================
    doc.setFont("helvetica", "bold");
    doc.setFontSize(13);
    doc.text(
      "Deposit Collection Report",
      pageWidth / 2,
      currentY + 14,
      { align: "center" }
    );
  
    // ================= TABLE =================
    const tableColumn = [
      "Sr",
          "Customer",
          "Account No",
          "Installment",
          "Amount",
          "Due Date",
          "Paid Date",
          "Mode",
    ];
  
    const tableRows = currentData.map((r, index) => [
      startIndex + index + 1,
      r.account?.customerName||"N/A",
      r.account?.accountNo||"N/A",
      r.installmentNo||"N/A",
      r.amount||"N/A",
      new Date(r.dueDate).toLocaleDateString("en-GB")||"N/A",
      r.collectionDate
        ? new Date(r.collectionDate).toLocaleDateString("en-GB")
        : "N/A",
      r.collectionType||"N/A",
    ]);
  
    const totalRow = [
      { content: "Total", colSpan: 4, styles: { halign: "right", fontStyle: "bold" } },
      { content: totalAmount.toLocaleString("en-IN"), styles: { fontStyle: "bold" } },
      "", "", ""
    ];
  
autoTable(doc, {
  startY: currentY + 20,
  head: [tableColumn],
  body: tableRows,
  foot: [totalRow],

  showFoot: "lastPage", // 🔥 IMPORTANT LINE

  theme: "grid",
  styles: {
    fontSize: 7,
    cellPadding: 3,
    halign: "center",
  },
  headStyles: {
    fontStyle: "bold",
    fontSize: 7,
  },
  footStyles: {
    fillColor: [220, 220, 220],
    textColor: 20,
    fontStyle: "bold",
    fontSize: 8,
  },
  alternateRowStyles: {
    fillColor: [245, 245, 245],
  },

  didDrawPage: function () {
    const pageWidth = doc.internal.pageSize.width;
    const pageHeight = doc.internal.pageSize.height;

    doc.setDrawColor(0);
    doc.setLineWidth(0.2);

    // Page border on EVERY page
    doc.rect(8, 8, pageWidth - 16, pageHeight - 16);
  },
});

  
    // ================= FOOTER =================
    const pageCount = doc.internal.getNumberOfPages();
    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i);
      doc.setFontSize(8);
      doc.setTextColor(100);
      doc.text(
        `Page ${i} of ${pageCount}`,
        pageWidth - 30,
        pageHeight - 10
      );
      doc.text(
        "Generated by Collection System",
        14,
        pageHeight - 10
      );
    }
  
    doc.save("Deposit_Collection_Report.pdf");
  };


  // -----------------------------------
  // INDIVIDUAL SLIP
  // -----------------------------------
  const downloadSlip = (r) => {
    const doc = new jsPDF("p", "pt", "a5");

    doc.setFont("helvetica", "bold");
    doc.setFontSize(14);

    doc.text(company?.name || "Company Name", 20, 30);
    doc.setFontSize(9);
    doc.text(company?.address || "-", 20, 45);

    doc.setFontSize(12);
    doc.text("Deposit Collection Slip", 20, 80);

    autoTable(doc, {
      startY: 95,
      theme: "grid",
      styles: { fontSize: 10, cellPadding: 3 },
      body: [
        [`Customer Name: ${r.account?.customerName}`],
        [`Account No: ${r.account?.accountNo}`],
        [`Installment No: ${r.installmentNo}`],
        [`Amount: ₹${r.amount}`],
        [
          `Paid Date: ${
            r.collectionDate
              ? new Date(r.collectionDate).toLocaleDateString("en-IN")
              : "-"
          }`,
        ],
        [`Mode: ${r.collectionType || "-"}`],
      ],
    });

    doc.save(`DepositSlip_${r.id}.pdf`);
  };


const printOrDownloadThermalSlip = async () => {
    if (!slipRef.current) return;

    const { jsPDF } = await import("jspdf");
    const html2canvas = (await import("html2canvas")).default;

    // 1️⃣ Render slip to canvas
    const canvas = await html2canvas(slipRef.current, { scale: 3, backgroundColor: "#ffffff" });
    const imgData = canvas.toDataURL("image/png");

    // 2️⃣ Prepare PDF (thermal size)
    const pdfWidth = 58; // mm
    const imgWidth = pdfWidth;
    const imgHeight = (canvas.height * pdfWidth) / canvas.width;

    const pdf = new jsPDF({ orientation: "portrait", unit: "mm", format: [pdfWidth, imgHeight] });
    pdf.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);

    // 3️⃣ Try to open print window
    try {
      const printWindow = window.open("", "_blank", "width=1000,height=600");

      printWindow.document.write(`
        <html>
          <head>
            <title>Print Slip</title>
            <style>
              @page { size: 58mm auto; margin:0; }
              body { margin:0; padding:0; text-align:center; }
              img { width:58mm; max-width:58mm; }
            </style>
          </head>
          <body>
            <img src="${imgData}" />
          </body>
        </html>
      `);

      printWindow.document.close();

      // Wait for print window to load
      printWindow.onload = () => {
        printWindow.focus();
        printWindow.print();
        // Optional: close after printing
        setTimeout(() => printWindow.close(), 500);
      };

    } catch (err) {
      // 4️⃣ Fallback → Download PDF
      pdf.save(`EMI_Slip_${selectedCustomer?.accountNo}.pdf`);
    }
  };

  // -----------------------------------
  // UI
  // -----------------------------------
  return (
    <div className="DdCollectionReport-wrapper">
      <h1 className="DdCollectionReport-title">📋 Deposit Collection Report</h1>

      {/* Controls */}
      <div className="DdCollectionReport-controls">
        <label>
          Show{" "}
          <select
            value={rowsPerPage}
            onChange={(e) => {
              setRowsPerPage(Number(e.target.value));
              setCurrentPage(1);
            }}
          >
            <option value={10}>10</option>
            <option value={25}>25</option>
            <option value={50}>50</option>
          </select>{" "}
          entries
        </label>

        <button className="filter-btn" onClick={downloadPDF}>
          📄 Download PDF
        </button>
      </div>

      <div className="DdCollectionReport-table-container">
        {loading ? (
          <p className="CollectionReport-loading">⏳ Loading...</p>
        ) : (
          <table className="DdCollectionReport-table">
            <thead>
              <tr>
                <th>#</th>
                <th>Customer</th>
                <th>Account No</th>
                <th>Installment No</th>
                <th>Amount</th>
                <th>Due Date</th>
                <th>Paid Date</th>
                <th>Mode</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody>
              {currentData.map((r, idx) => (
                <tr key={r.id}>
                  <td>{startIndex + idx + 1}</td>
                  <td>{r.account?.customerName||"N/A"}</td>
                  <td>{r.account?.accountNo||"N/A"}</td>
                  <td>{r.installmentNo||"N/A"}</td>
                  <td>{`₹${r.amount}`||"N/A"}</td>
                  <td>{new Date(r.dueDate).toLocaleDateString("en-GB")||"N/A"}</td>
                  <td>
                    {r.collectionDate
                      ? new Date(r.collectionDate).toLocaleDateString("en-GB")
                      : "N/A"}
                  </td>
                  <td>{r.collectionType ||"N/A"}</td>
                  <td>
                    <button
                      className="slip-btn-Ddcollection-report"
                      // onClick={() => downloadSlip(r)}
                      onClick={() => {
                          setSelectedCustomer(r);
                          printOrDownloadThermalSlip();
                        }}
                    >
                      🧾 Slip
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>

            <tfoot>
              <tr className="CollectionReport-total-row">
                <td colSpan="4" style={{ textAlign: "right" }}>
                  Total:
                </td>
                <td style={{ fontWeight: "bold" }}>₹{totalAmount}</td>
                <td colSpan="4"></td>
              </tr>
            </tfoot>
          </table>
        )}
      </div>

      {/* Pagination */}
      <div className="CollectionReport-pagination">
        <button className="pagination-btn" onClick={handlePrev} disabled={currentPage === 1}>
          ⬅ Prev
        </button>
        <span className="pagination-info">
          Page {currentPage} of {totalPages || 1}
        </span>
        <button
          className="pagination-btn"
          onClick={handleNext}
          disabled={currentPage === totalPages}
        >
          Next ➡
        </button>
      </div>

       {/* Hidden thermal print container */}
       <div style={{ position: "absolute", left: "-10000px" }}>
          <div
            ref={slipRef}
            style={{
              width: "230px",           // 58mm thermal printer width
              padding: "10px",
              border:"1px solid #ccc",
              fontFamily: "Courier New, monospace",
              fontSize: "12px",
              lineHeight: "1.2",
            }}
          >


             <div style={{ textAlign: "center"}}>
                  <div style={{ textAlign: "center", fontWeight: "bold", fontSize: "14px" }}>
                    {company?company.name:"--"}
                  </div>
                  <div style={{ textAlign: "center", fontWeight: "semi-bold", fontSize: "9px" }}>
                    <b>Contact No.:</b> {company?company.contact:"--"}
                  </div>
                  <div style={{ textAlign: "center", fontWeight: "semi-bold", fontSize: "9px" }}>
                    <b>Address.:</b> {company?company.address:"--"}
                  </div>
              </div>


            <div style={{ textAlign: "center",marginTop:"10px", fontWeight: "bold", fontSize: "14px" }}>
             Deposit Collection Slip
            </div>

            <div style={{ borderBottom: "1px dashed #000", margin: "10px 0" }}></div>

            <div><b>Customer Name:</b> {selectedCustomer?.account?.customerName}</div>
            <div><b>Account No.:</b> {selectedCustomer?.account?.accountNo || "--"}</div>
            <div><b>Installment No.:</b> {selectedCustomer?.installmentNo || "--"}</div>
            <div><b>Paid Amount:</b>{selectedCustomer?.amount || "--"}</div>
            <div><b>Paid Date:</b>{selectedCustomer?.collectionDate?
                                 new Date(selectedCustomer.collectionDate).toLocaleDateString("en-IN")
                                : "--"}</div>
            <div><b>Payment Mode:</b> {selectedCustomer?.collectionType || "--"}</div>

            <div style={{ borderBottom: "1px dashed #000", margin: "10px 0" }}></div>

            <div style={{ textAlign: "center" }}>Thank you!</div>
            <div style={{ textAlign: "center" }}>--- {company ? company.name.split(" ")[0] : "End of "} Slip ---</div>
          </div>
       </div>

    </div>
  );
};

export default DdCollectionReport;
